module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fixedholder-gb', [_c('div', {
    class: [_vm.block]
  }, _vm._l((_vm.data.expandableGroups), function(expandableGroup, groupIndex) {
    return _c('div', {
      class: [_vm.block] + '-expandableGroup'
    }, [_c('div', {
      class: [_vm.block] + '-headers'
    }, _vm._l((expandableGroup.headers), function(header, index) {
      return _c('span', {
        class: (_vm.block + "-header " + _vm.block + "-header" + index)
      }, [_vm._v(_vm._s(header))])
    })), _vm._v(" "), _vm._l((expandableGroup.expandables), function(expandable, index) {
      return _c('div', [_c('columnedexpandable-block', {
        attrs: {
          "index": groupIndex + '-' + index,
          "active": _vm.data.active,
          "data": expandable,
          "icon": _vm.icon,
          "rotate45": _vm.data.rotate45,
          "iconLeft": _vm.data.iconLeft
        },
        on: {
          "activeExpandableChanged": _vm.toggleQuestion
        }
      })], 1)
    })], 2)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eae33cb","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/combinedBlocks/ColumnedExpandablelist.vue
// module id = 472
// module chunks = 0